/*!
 * Copyright Optimus Ride 2019
 */

import moment from 'moment';

export const THEME_COLOR = '#FFFFFF';

export const GRPC_URL = process.env.GRPC_HOSTNAME;

export const ORI_API_KEY = process.env.ORI_API_KEY;

export const FIREBASE_PUBLIC_VAPID_KEY = process.env.FIREBASE_PUBLIC_VAPID_KEY;

export const FIREBASE_CONFIG = {
  apiKey: process.env.FIREBASE_API_KEY,
  audience: process.env.FIREBASE_AUDIENCE,
  /* TODO(peter-or): Change the naming on this env variable to reflect the name projectId */
  projectId: process.env.FIREBASE_AUDIENCE,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  appId: process.env.FIREBASE_APP_ID
};

export const GRPC_PLACES_PORT = '9009';
export const GRPC_REMOTE_MONITOR_PORT = '9005';
export const GRPC_RESERVATION_PORT = '9004';
export const GRPC_SITE_PORT = '9003';
export const GRPC_STATION_PORT = '9002';
export const GRPC_USER_PORT = '9001';

export const GOOGLE_MAPS_API_KEY = 'AIzaSyBVUX6ABpmSPGuv7ePyQUYlsO-Iyo_ORTo';
export const GOOGLE_MAPS_API_URL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&v=3.exp`;

export const abbreviatedFullDate = 'iii, LLL d, yyyy';
export const timeFormat = 'h:mm A';
export const dateFormat = moment.HTML5_FMT.DATE;
export const iso8601Time = moment.HTML5_FMT.TIME;

export const STATES = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'District Of Columbia', value: 'DC' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS'},
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Puerto Rico', value: 'PR' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
];

export const OPTIMUS_RIDE = 'Optimus Ride';
export const OPTIMUS_RIDE_DOMAIN = 'optimusride.com';
export const OPTIMUS_RIDE_URL = `https://${OPTIMUS_RIDE_DOMAIN}`;
export const OPTIMUS_RIDE_TAGLINE = 'Connecting people with self-driving cars';
export const TECH_SUPPORT_EMAIL = 'techsupport@optimusride.com';

export const COMMANDOR_URL = `https://commandor.${OPTIMUS_RIDE_DOMAIN}`;

export enum APPLICATION_NAME {
  COMMAND = 'COMMAND',
  COMMANDOR = 'COMMANDOR',
  OPTI = 'OPTI',
  ORIDE = 'ORIDE',
  SYNC_STATION = 'SYNC_STATION',
  IVE = 'IVE'
}

export const APPLICATION_TITLES = {
  COMMAND : 'Command',
  COMMANDOR: 'CommandOR',
  ORIDE: OPTIMUS_RIDE,
  SYNC_STATION: 'Sync Station',
};

export const RIDE_TIME_PADDER = 5;

export const ONE_MINUTE_INTERVAL_IN_MS = 60000;

export const FIVE_MINUTE_INTERVAL = 300000;

export const FIFTEEN_MINUTE_INTERVAL_IN_MS = 900000;

export const ONE_SECOND_INTERVAL = 1000;

export const TEN_SECOND_INTERVAL = 10000;

export const MILLISECONDS_PER_MICROSECOND = 1000;

export const MILLISECONDS_IN_ONE_SECOND = 1000;

export const SEATS_PER_ROW = 2;

export const PHONE_FOR_SIGN_IN_LS_KEY = 'phoneForSignIn';

export const EMAIL_FOR_SIGN_IN_LS_KEY = 'emailForSignIn';

export const OPERATING_AREA_ID_LS_KEY = 'operatingAreaId';

// TODO: Move this out of constants
export const operatingAreas = [
  { id: 1, name: 'Boston Seaport', abbrName: 'sp',  latLonCenter:{ latitude:42.347171, longitude:-71.029504} },
  { id: 3, name: 'Brooklyn Navy Yard', abbrName: 'ny', latLonCenter:{ latitude:40.699388, longitude:-73.972976} },
  { id: 4, name: 'Halley Rise', abbrName: 'va', latLonCenter:{ latitude:38.948428, longitude:-77.360421} },
  { id: 5, name: 'Paradise Valley Estates', abbrName: 'pv', latLonCenter:{ latitude:38.304323, longitude:-122.028364} },
  { id: 6, name: 'Union Point', abbrName: 'rw', latLonCenter:{ latitude:42.156522, longitude:-70.949757} },
  { id: 7, name: 'The Yards', abbrName: 'ty', latLonCenter:{ latitude:38.877752, longitude:-77.00426} },
];
